import React, { useState, useRef, useEffect, Children, isValidElement, cloneElement } from 'react';

const App = ({ children, title = '', defaultOpen = true }) => {
  const [open, setOpen] = useState(defaultOpen);
  const [over, setOver] = useState(false);
  const [height, setHeight] = useState(0);
  const containRef = useRef();
  useEffect(
    () => {
      if (containRef.current && (height !== containRef.current.clientHeight)) {
        setHeight(containRef.current.clientHeight);
      }
    },
  );
  return (
    <div style={{
      marginRight: 40,
      marginLeft: 20,
      marginTop: 20,
      backgroundColor: '#EBF3F5',
      borderRadius: 8,
      boxShadow: open ? '' : '0px 4px 13px rgba(24, 98, 121, 0.4)',
      flexShrink: 0,
    }}
    >
      <div
        style={{
          height: 50,
          backgroundColor: over ? '#E3F6FB' : 'white',
          color: over ? '#247690' : '#FF6B17',
          border: `1px solid ${over ? '#247690' : 'rgba(1, 149, 142, 0.4)'}`,
          borderRadius: 8,
          fontWeight: 700,
          fontSize: 20,
          lineHeight: '50px',
          cursor: 'pointer',
          textAlign: 'center',
        }}
        onClick={() => setOpen(!open)}
        onMouseOver={() => setOver(true)}
        onMouseOut={() => setOver(false)}
      >
        {title}
      </div>
      <div style={{
        position: 'relative',
      }}
      >
        <div style={{
          overflow: 'hidden',
          transition: 'max-height 0.5s',
          maxHeight: open ? height : 0,
        }}
        >
          <div ref={containRef} style={{ display: 'flex', flexDirection: 'column' }}>
            {Children.map(children, child => {
              if (!isValidElement(child)) return null;
              return cloneElement(child, {
                ...child.props,
                open,
              });
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
